import { render, staticRenderFns } from "./OfCodeInput.vue?vue&type=template&id=72cd5747&scoped=true"
import script from "./OfCodeInput.vue?vue&type=script&lang=js"
export * from "./OfCodeInput.vue?vue&type=script&lang=js"
import style0 from "./OfCodeInput.vue?vue&type=style&index=0&id=72cd5747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd5747",
  null
  
)

export default component.exports